import { Component } from '@angular/core';

@Component({
  selector: 'app-pw-submit-popup',
  templateUrl: './pw-submit-popup.component.html',
  styleUrls: ['./pw-submit-popup.component.scss']
})
export class PwSubmitPopupComponent {

}
